import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'recaudacion/giros-de-alcoholes/';

/**
 * GET Giros de Alcoholes
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getGirosDeAlcoholes = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Giro de Alcoholes
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getGiroDeAlcoholes = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Giro de Alcoholes
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postGiroDeAlcoholes = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Giro de Alcoholes
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchGiroDeAlcoholes = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Giro de Alcoholes
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteGiroDeAlcoholes = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
